import React from "react";
import loadable from "@loadable/component";
import CenterSpinner from "../../common/centerSpinner";

function AsyncViewAllPosts({ ...rest }) {
  const AsyncLoad = loadable(() => import("../page/viewAllPosts"));
  console.log("Loading", AsyncViewAllPosts.name);
  return <AsyncLoad {...rest} fallback={<CenterSpinner />} />;
}

export default AsyncViewAllPosts;
